module.exports = __webpack_public_path__ + "media/images/glyphs/add-note-c1b3c68d2661d681be0a1b5ed4e47ae4.svg";